export default {
    updateSupport: (state, supportToAdd) => {
        state.supports[supportToAdd.guid] = supportToAdd;
        state.supportsGuid = Object.keys(state.supports);
    },
    removeSupport: (state, supportToRemove) => {
        delete state.supports[supportToRemove.guid];
        state.supportsGuid = Object.keys(state.supports);
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/Support/mutations.js